import GroupCreateModalBase from '../../2compounds/GroupCreateModalBase'
import {useEffect, useState} from 'react'
import TerritoriesCheckBoxList from '../../2compounds/TerritoriesCheckBoxList'
import {deepCopyObjectArray} from '../../../services/util/miscellaneousService'

const SelectTerritoriesModal = ({open, setOpen, territories, setTerritories}) => {
    const [territoriesTemp, setTerritoriesTemp] = useState([])

    const cancelHandler = () => {
        setOpen(false)
    }

    const saveHandler = () => {
        setTerritories(territoriesTemp)
        setOpen(false)
    }

    useEffect(()=>{
        const deepCopiedTerritories = deepCopyObjectArray(territories)
        setTerritoriesTemp(deepCopiedTerritories)
    }, [territories, open])

    return (
        <GroupCreateModalBase header='Assign territories'
                              saveHandler={saveHandler}
                              cancelHandler={cancelHandler}
                              open={open}
                              setOpen={setOpen}>
            <TerritoriesCheckBoxList territories={territoriesTemp} setTerritories={setTerritoriesTemp} />
        </GroupCreateModalBase>
    )
}

export default SelectTerritoriesModal
